import { render, staticRenderFns } from "./EditCriterionModalForm.vue?vue&type=template&id=45724faa&scoped=true&"
import script from "./EditCriterionModalForm.vue?vue&type=script&lang=ts&"
export * from "./EditCriterionModalForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditCriterionModalForm.vue?vue&type=style&index=0&id=45724faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45724faa",
  null
  
)

export default component.exports